import {Clicker} from "../components/Clicker";
import {useDispatch} from "react-redux";
import {useAuth} from "../hooks/use-auth";
import {getAuth, onAuthStateChanged} from "firebase/auth";
import {removeUser, setUser} from "../store/slices/userSlices";
import React, {useState} from 'react';
import {Navigate, useNavigate} from 'react-router-dom';
import {getFirestore, doc, getDoc} from "firebase/firestore";

const MainPage = () => {

    const dispatch = useDispatch();
    const db = getFirestore();
    let money1 = 0,
        count = 0,
        level = 0;
    const {isAuth, email} = useAuth();
    const [username, setUserName] = useState();

    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
        if (user) {
            const uid = user.uid;
            getDoc(doc(db, "userinfo", uid)).then(docSnap => {
                if (docSnap.exists()) {
                    setUserName(docSnap.data().name.name)
                    money1 = docSnap
                        .data()
                        .money;
                } else {
                    console.log("No such document!");
                }
            })
        } else {}
    });

    let navigate = useNavigate();
    return isAuth
        ? (
            <div>
                <div className="wrapper">

                    <div className="nav">
                        <button className="but__upgrade main__text right">
                            Никнейм: {username}</button>
                        <div className="left">
                            <button
                                className="but__upgrade main__text"
                                onClick={() => dispatch(removeUser())}>
                                Выйти</button>
                        </div>
                    </div>
                    <Clicker/>
                </div>

            </div>
        )
        : (<Navigate to={"/welcome"}/>)
}

export {
    MainPage
};